import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Container} from "react-bootstrap";

const screenshotKeys = [
	{key: "checklist", image: "/images/screen-checklist.svg"},
	{key: "task", image: "/images/screen-task.svg"},
	{key: "timeline", image: "/images/screen-timeline.svg"},
];

export const Screenshots: FC = () => {
	const {t} = useTranslation();

	return (
		<section className="section" id="screenshots">
			<Container>
				<div className="section__head">
					<h2 className="section__title">{t("screenshots.title")}</h2>
					<p className="section__subtitle">{t("screenshots.subtitle")}</p>
				</div>
				<div className="row g-4 justify-content-center">
					{screenshotKeys.map(({key, image}) => (
						<div key={key} className="col-12 col-sm-8 col-md-4">
							<figure className="screenshot">
								<div className="screenshot__frame">
									<img src={image} alt={t(`screenshots.items.${key}.alt`)} />
								</div>
								<figcaption className="screenshot__caption">
									{t(`screenshots.items.${key}.caption`)}
								</figcaption>
							</figure>
						</div>
					))}
				</div>
			</Container>
		</section>
	);
};
